import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { dropdownTitle, selectContainerStyle } from "./orderDetailsStyles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Colors from "../../theme/Colours";
type DatePickerProps = {
  selectedDate: moment.Moment | null;
  setSelectedDate: (val: moment.Moment | null) => void;
  disabled?: boolean;
};

export const DatePicker: FC<DatePickerProps> = ({
  selectedDate,
  setSelectedDate,
  disabled = false,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Box sx={{ flexDirection: "row" }}>
        <Typography sx={dropdownTitle} mb={"30px"}>
          Update ETA
        </Typography>
        <MuiDatePicker
          value={selectedDate}
          onChange={(newValue) => {
            if (!disabled) {
              setSelectedDate(newValue);
            }
          }}
          format="DD/MM/YYYY"
          disablePast={!selectedDate}
          disabled={disabled}
          readOnly={disabled}
          slots={{
            openPickerIcon: !disabled ? KeyboardArrowDownIcon : undefined,
          }}
          sx={{
            "& .MuiInputBase-root": {
              ...selectContainerStyle,
              border: `1px solid ${Colors.black}`,
              borderRadius: "8px",
              ...(disabled && {
                opacity: 0.6,
                backgroundColor: Colors.greyBackground || "#f5f5f5",
                color: "text.disabled",
                pointerEvents: "none",
              }),
            },
            ...(disabled && {
              pointerEvents: "none",
            }),
            "& .MuiOutlinedInput-root:hover": {
              border: `1px solid ${Colors.black}`,
            },
            "& .MuiOutlinedInput-root.Mui-focused": {
              border: `1px solid ${Colors.black}`,
            },
            "& fieldset": {
              border: "none",
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};
